import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import "core-js/modules/es.array.push.js";
import axios from 'axios';
import router from '@/router/index.js';
// import store from '@/store/index'       //已经设置路径别名，否则相对路径引用
// import { ElMessage, ElLoading } from "element-plus";
import env from '@/env';
import { removeLocalStorage, saveLoginRedirectUrl } from '@/utils/utils';
let loading = null;
let showMsg = true;
const service = axios.create({
  // timeout: 10000,                                   //超时时间
  baseURL: env.baseUrl // 我们在请求接口的时候就不用写前面 会自动我们补全
});
const shouldSkipLoading = config => {
  if (config?.hideLoading) {
    return true;
  }
  // 轮询类接口不展示全局 Loading
  return config?.url === '/merchant/v2/message/message_num';
};
const shouldSkipPollErrorUi = config => {
  return Boolean(config?.hideLoading) || config?.url === '/merchant/v2/message/message_num';
};

// http request 拦截器
service.interceptors.request.use(config => {
  if (localStorage.getItem('token')) {
    config.headers.token = localStorage.getItem('token');
  }
  if (!shouldSkipLoading(config) && config.url != '/merchant/v2/schedule/set_day' && config.url != '/merchant/v2/schedule/export_pdf' && config.url != '/merchant/v2/schedule_score/export_pdf' && config.url != '/merchant/v2/salary/alipay_agreement/select_sign' && config.url != '/merchant/v2/salary/account_recharge/select_recharge' && config.url != '/merchant/v2/labor/electronic_signature/quit/get_contract_loading' && config.url != '/merchant/v2/labor/store_clerk_commission_detail/get_loading_status' && config.url != '/merchant/v2/qiniu/get_private_download_url' && config.url != '/merchant/v2/qiniu/get_upload_token' && config.url != '/merchant/v2/labor/store_cash/one_data/import_status') {
    loading = ElLoading.service({
      lock: true,
      text: '加载中...',
      background: 'transparent'
      // background: 'rgba(0, 0, 0, 0.1)',
    });
  }
  return config;
}, err => {
  return err;
});
// http response 拦截器
service.interceptors.response.use(response => {
  if (response.status === 204) {
    loading.close();
    return {
      status: 204
    };
  }
  if (response.status === 200) {
    if (response.data && response.data.code == 200) {
      if (!shouldSkipLoading(response.config)) {
        loading.close();
      }
      return response.data;
    } else if (response.data && response.data.size && response.data.type) {
      let filname = '';
      if (response.headers["content-disposition"]) {
        filname = response.headers["content-disposition"].toLowerCase().split("filename*=utf-8''")[1] || '';
      }
      const fileName = decodeURIComponent(filname);
      const link = document.createElement('a');
      let blob = new Blob([response.data], {
        type: response.data.type
        // type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // ElMessage({
      //     type: 'success',
      //     message:'操作成功'
      // })

      return loading.close();
    } else {
      loading.close();
      // Let callers handle specific business codes / opted-out APIs
      if (response.config?.skipGlobalErrorHandler || Number(response.data?.code) === 46001) {
        return Promise.reject(response.data);
      }
      console.log(1111111111111111);
      if (response.data instanceof Blob) {
        // 针对批量文件流异常的处理（例如批量下载电子签，接口为/api/admin/tencent_contract_renew/download_batch）
        // 1.将文件流进行反解析
        const reader = new FileReader();
        reader.readAsText(response.data);
        reader.onload = () => {
          // 2.捕获异常
          try {
            const errorData = JSON.parse(reader.result);
            // console.log(errorData)
            if (errorData.msg) {
              // 3.显示错误消息
              let msgs = errorData.msg;
              return showMessage(msgs);
            } else {
              console.error('未知错误');
            }
          } catch (e) {
            console.error('无法解析错误消息');
          }
        };
        reader.onerror = () => {
          console.error('读取 Blob 错误');
        };
      } else {
        return showMessage(response.data.msg);
      }
    }
  } else {
    console.log(44444444444);
    loading.close();
    if (response.data instanceof Blob) {
      // 针对批量文件流异常的处理（例如批量下载电子签，接口为/api/admin/tencent_contract_renew/download_batch）
      // 1.将文件流进行反解析
      const reader = new FileReader();
      reader.readAsText(response.data);
      reader.onload = () => {
        // 2.捕获异常
        try {
          const errorData = JSON.parse(reader.result);
          // console.log(errorData)
          if (errorData.msg) {
            // 3.显示错误消息
            let msgs = errorData.msg;
            return showMessage(msgs);
          } else {
            console.error('未知错误');
          }
        } catch (e) {
          console.error('无法解析错误消息');
        }
      };
      reader.onerror = () => {
        console.error('读取 Blob 错误');
      };
    } else {
      return showMessage(response.data.msg);
    }
  }
}, err => {
  loading?.close?.();
  // Business-code rejects from the success interceptor (plain response body)
  if (err && !err.response && (err.code || err.msg)) {
    return Promise.reject(err);
  }
  const responseData = err?.response?.data;
  const key = generateErrorKey(err);
  const now = Date.now();
  const CACHE_DURATION = 5000; // 缓存5秒，按需调整
  if (responseData?.code != 456) {
    if (showMsg && !shouldSkipPollErrorUi(err.config)) {
      // 如果错误不在缓存中，或缓存已过期
      if (!errorCache.has(key) || errorCache.get(key).expire <= now) {
        // 处理错误：提示用户、跳转登录等
        showMessage(responseData?.message || responseData?.msg);

        // 更新缓存（记录当前时间 + 缓存时长）
        errorCache.set(key, {
          expire: now + CACHE_DURATION
        });
      }
    }
  }
  if (responseData?.code == 401 && !shouldSkipPollErrorUi(err.config)) {
    if (showMsg) {
      showMsg = false;
      setTimeout(() => {
        showMsg = true;
      }, 3000);
    }
    // 记录当前访问地址，登录成功后直接跳回该菜单
    saveLoginRedirectUrl();
    removeLocalStorage();
    // localStorage.removeItem('token')
    // localStorage.removeItem('userInfo')
    // localStorage.removeItem('app_id')
    // localStorage.removeItem('main_merchant_id')
    // localStorage.removeItem('activeIndex')
    // localStorage.setItem('recentlyUsed',JSON.stringify([]))
    setTimeout(() => {
      router.push({
        name: 'Login',
        path: '/login'
      });
    }, 2000);
  } else if (responseData?.code == 456) {
    router.push({
      name: 'NotFound',
      path: '/404'
    });
  }
  return Promise.reject(responseData || err);
});
//封装错误提示信息..
function showMessage(message = '请求错误', type = "error", showClose = true) {
  ElMessageBox.alert(message.replace(/\r?\n/g, '<br/>'), '温馨提示', {
    confirmButtonText: '确定',
    dangerouslyUseHTMLString: true
  });
  loading.close();
  return Promise.reject();
}
const errorCache = new Map();

// 生成错误唯一标识的示例方法（根据需求调整）
const generateErrorKey = error => {
  const {
    status,
    message
  } = error.response || {};
  const url = error.config?.url || '';
  return `${status}-${message}`;
};
export default service;